import styled from "styled-components";
import { DefaultTextProps, TextProps } from "./Text.types.js";

export const fontWeightMap: Record<NonNullable<TextProps["weight"]>, number> = {
    normal: 400,
    semibold: 500,
    bold: 700,
};

export const fontSizeMap: Record<NonNullable<TextProps["size"]>, number> = {
    large: 1.5,
    medium: 1.125,
    small: 1,
    "x-small": 0.875,
    "xx-small": 0.75,
};

export const StyledText = styled.span<TextProps & DefaultTextProps>`
    text-align: ${(props) => props.align};
    color: ${(props) => props.color};
    font-weight: ${(props) => fontWeightMap[props.weight]};
    font-size: ${(props) => props.theme.rem(fontSizeMap[props.size])};
    white-space: ${(props) => props.whiteSpace};
    word-break: ${(props) => props.wordBreak};
    font-style: ${(props) => props.fontStyle};
    line-height: normal;
    letter-spacing: 0;
    margin: 0;
    -webkit-font-smoothing: antialiased;
    ${({ toUpperCase }) => toUpperCase && `text-transform: uppercase;`}
    ${({ capitalize }) => capitalize && `text-transform: capitalize;`}
    ${({ strikeTrough }) => strikeTrough && `text-decoration: line-through;`}
    ${({ onClick }) => onClick && `cursor: pointer;`}
`;
